import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import User from '../views/User.vue'
import Player from '../views/Player.vue'
import Admin from '../views/Admin.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/user',
        name: 'User',
        component: User
    },
    {
        path: '/purchased',
        name: 'Purchased',
        component: () => import('../views/Purchased.vue')
    },
    {
        path: '/player',
        name: 'Player',
        component: Player
    },
    {
        path: '/admin',
        name: 'Admin',
        component: Admin
    },
    {
        path: '/payment-result',
        name: 'PaymentResult',
        component: () => import('../views/PaymentResult.vue')
    },
    {
        path: '/cashier',
        name: 'Cashier',
        component: () => import('../views/Cashier.vue')
    },
    {
        path: '/payment-processing',
        name: 'PaymentProcessing',
        component: () => import('../views/PaymentProcessing.vue')
    },
    {
        path: '/payment-debug',
        name: 'PaymentDebug',
        component: () => import('../views/PaymentDebug.vue')
    },
    {
        path: '/access-denied',
        name: 'AccessDenied',
        component: () => import('../views/AccessDenied.vue')
    }
]

const router = new VueRouter({
    routes
})

// 域名访问控制
const ADMIN_DOMAIN = 'gogo123.co';
const LOCAL_DOMAINS = ['localhost', '127.0.0.1'];

router.beforeEach((to, from, next) => {
    const hostname = window.location.hostname;
    const isAdminDomain = hostname === ADMIN_DOMAIN;
    const isLocalDomain = LOCAL_DOMAINS.includes(hostname);
    const isAdminRoute = to.path.startsWith('/admin');
    const isAccessDenied = to.path === '/access-denied';

    // 访问错误页面时不拦截
    if (isAccessDenied) {
        return next();
    }

    // 本地开发环境：允许访问所有页面
    if (isLocalDomain) {
        return next();
    }

    // 非管理域名访问后台 → 拒绝
    if (isAdminRoute && !isAdminDomain) {
        console.warn('Admin access denied: not from admin domain');
        return next('/access-denied');
    }

    // 管理域名访问客户页面 → 强制跳转到后台
    if (!isAdminRoute && isAdminDomain) {
        console.warn('Customer page access denied: admin domain');
        return next('/admin');
    }

    next();
});

export default router
